import React from 'react';
import { ScanBarcode, Users, QrCode, Box, BarChart3, ShieldCheck, Globe, BellRing, Zap } from 'lucide-react';

const Features = () => {
  const features = [
    {
      title: "Barcode Billing",
      desc: "Scan products and create bills in seconds. No manual typing needed.",
      icon: <ScanBarcode size={24} />,
      color: "bg-blue-50 text-blue-600"
    },
    {
      title: "Customer Management",
      desc: "Track purchases, manage credit (udhar), and send automated reminders.",
      icon: <Users size={24} />,
      color: "bg-purple-50 text-purple-600"
    },
    {
      title: "QR Menu Ordering",
      desc: "Customers scan QR and order directly. No waiters or manual entry needed.",
      icon: <QrCode size={24} />,
      color: "bg-orange-50 text-orange-600"
    },
    {
      title: "Smart Inventory",
      desc: "Auto-track stock levels. Get alerts before items run out.",
      icon: <Box size={24} />,
      color: "bg-emerald-50 text-emerald-600"
    },
    {
      title: "Sales Analytics",
      desc: "Daily, weekly, and monthly reports to help you know what sells best.",
      icon: <BarChart3 size={24} />,
      color: "bg-red-50 text-red-600"
    },
    {
      title: "Payment Reminders",
      desc: "Auto-send WhatsApp reminders for pending payments to customers.",
      icon: <BellRing size={24} />,
      color: "bg-yellow-50 text-yellow-600"
    }
  ];

  return (
    <section id="features" className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-emerald-600 font-bold uppercase tracking-widest text-sm mb-3">Features</h2>
          <h3 className="text-4xl font-bold text-slate-900">Everything You Need To Run Your Shop Better</h3>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {features.map((f, index) => (
            <div key={index} className="bg-white p-8 rounded-3xl shadow-sm border border-slate-100 hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
              <div className={`${f.color} w-14 h-14 rounded-2xl flex items-center justify-center mb-6`}>
                {f.icon}
              </div>
              <h4 className="text-xl font-bold text-slate-900 mb-3">{f.title}</h4>
              <p className="text-gray-600 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;